"use client";

import React from "react";
import { Mail } from "lucide-react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface CtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, CtaCopy> = {
  en: {
    eyebrow: "Alloy Selection & Engineering",
    heading: "Specify Your Stainless Steel Wire Mesh Requirements",
    lead: "Send your target aperture, weave style, and alloy grade. Our engineering team reviews specifications and returns technical pricing tailored to your filtration setup.",
    secondaryLabel: "Contact Our Engineers"
  },
  zh: {
    eyebrow: "合金牌号选型与工程支持",
    heading: "明确您的不锈钢丝网技术规格需求",
    lead: "提供您的目标孔径、编织类型及合金牌号，我们的工程团队将核对公差并为您的过滤系统提供精准的技术报价。",
    secondaryLabel: "咨询技术工程师"
  },
  es: {
    eyebrow: "Selección de aleación e ingeniería",
    heading: "Especifique sus requisitos de malla de alambre de acero inoxidable",
    lead: "Envíe su abertura, tipo de tejido y grado de aleación. Nuestro equipo técnico revisará los requerimientos para ofrecerle una propuesta competitiva.",
    secondaryLabel: "Contactar con ingenieros"
  },
  de: {
    eyebrow: "Legierungsauswahl & Engineering",
    heading: "Präzisieren Sie Ihre Anforderungen an Edelstahl-Drahtgewebe",
    lead: "Übermitteln Sie Maschenweite, Webart und Werkstoffgüte. Unser Fachteam prüft Ihre Toleranzen und erstellt ein passgenaues Angebot.",
    secondaryLabel: "Ingenieure kontaktieren"
  },
  fr: {
    eyebrow: "Sélection d'alliage et ingénierie",
    heading: "Définissez vos spécifications de toile en acier inoxydable",
    lead: "Transmettez votre ouverture de maille, type de tissage et nuance d'acier. Nos ingénieurs valident les tolérances et établissent une offre technique adaptée.",
    secondaryLabel: "Contacter un ingénieur"
  },
  pt: {
    eyebrow: "Seleção de liga e engenharia",
    heading: "Defina seus requisitos de tela de arame de aço inoxidável",
    lead: "Envie a abertura desejada, o tipo de tecelagem e a classe de liga. Nossa equipe analisa os requisitos e fornece cotação técnica ajustada à sua aplicação.",
    secondaryLabel: "Falar com engenheiro"
  }
};
export default function Quote() {
  const {
    lang
  } = useLanguage();
  const copy = pick(lang, copyData);
  return <CtaBand id="quotecta" eyebrow={copy.eyebrow} heading={copy.heading} lead={copy.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: copy.secondaryLabel,
    to: "/ContactPage",
    icon: Mail
  }} />;
}